import { gql } from '@apollo/client';

export const CALLBACKS_QUERY = gql`
    query callbacks {
        callbacks {
            edges {
                node {
                    id
                    type
                    url
                }
            }
        }
    }
`;
